<div class="bina-code-item">
  <div class="bina-code-item__box" [ngClass]="{ invalid: isInvalid }">
    <ng-container *ngIf="!!groupNumber; else emptyCapsule">
      {{ groupNumber }}
    </ng-container>
    <ng-template #emptyCapsule>
      <div class="bina-code-item__box__empty-capsule" *ngFor="let _ of capsulePlaceholdersArr"></div>
    </ng-template>
  </div>
  <div class="bina-code-item__dot" *ngIf="showDot"></div>
</div>
